import { render } from "./AfterSave.vue?vue&type=template&id=a95b8868&scoped=true"
import script from "./AfterSave.vue?vue&type=script&lang=js"
export * from "./AfterSave.vue?vue&type=script&lang=js"

import "./AfterSave.vue?vue&type=style&index=0&id=a95b8868&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a95b8868"

export default script